import {
  doc,
  getDoc,
} from "firebase/firestore";
// Ensure these paths are correct for your project
import { FIRESTORE_DB } from "../config";
import type { UserAccount } from "../../../interfaces/UserAccount"; // Corrected path/name for UserAccount interface


const COLLECTION_NAME = "users";

/**
 * Retrieves a user account by their ID.
 * @param userId The ID of the user (Firebase UID).
 * @returns A Promise that resolves to the UserAccount object or undefined if not found/error.
 */
export const getUser = async (
  userId: string | undefined,
): Promise<UserAccount | undefined> => {
  if (!userId) {
    console.warn("getUser called with undefined userId.");
    return undefined;
  }
  try {
    const userRef = doc(FIRESTORE_DB, COLLECTION_NAME, userId);
    const docSnap = await getDoc(userRef);
    if (docSnap.exists()) {
      // CRITICAL: Ensure the ID is explicitly attached from docSnap.id
      return { id: docSnap.id, ...(docSnap.data() as Omit<UserAccount, "id">) };
    } else {
      console.warn(`User with ID ${userId} does not exist!`);
    }
  } catch (e) {
    console.error(`Error getting user ${userId}:`, e);
  }
  return undefined;
};
